import React from 'react'
import Helmet from 'react-helmet'

import Banner from '../components/Banner'
import TrialBanner from '../components/TrialBanner'
import DeviceBanner from '../components/DeviceBanner'
import ColumnsRow from '../components/ColumnsRow'
import Testimonials from '../components/Testimonials'

// Export Template for use in CMS preview
export const FeaturesPageTemplate = ({ banner, contentRows, bottomContentRows, trialBanner, deviceBanner,  testimonials }) => {
    
    return <main className="Features-page">
        <Helmet>
            <title>Assetlogue – Our Features</title>
        </Helmet>
        <Banner
            {...banner}
            icon='features'
        />
        
        {contentRows.map((contentRow, index) => 
            <ColumnsRow
                key={index}
                className={`contentrow-top-${index} ${index % 2 == 0 ? '' : 'row-reverse'}`}
                {...contentRow}
            />
        )}

        <TrialBanner
            {...trialBanner}
        />

        {bottomContentRows.map((contentRow, index) => 
            <ColumnsRow
                key={index}
                className={`contentrow-bottom-${index} ${index % 2 == 0 ? '' : 'row-reverse'}`}
                {...contentRow}
            />
        )}

        <DeviceBanner
            {...deviceBanner}
        />

        <Testimonials
            background='light'
            {...testimonials}
        />


    </main>
}

// Export Default HomePage for front-end
const FeaturesPage = ({ data: { page, settingsYaml } }) => (
    <FeaturesPageTemplate {...page} {...page.frontmatter} {...settingsYaml} body={page.html} />
)

export const pageQuery = graphql`
  ## Query for HomePage data
  ## Use GraphiQL interface (http://localhost:8000/___graphql)
  ## $id is processed via gatsby-node.js
  ## query name must be unique to this file
  query FeaturesPage($id: String!) {
    page: markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        banner {
          buttonText
          buttonUrl
          description
          title
          subtitle
        }
        contentRows {
            buttonText
            buttonUrl
            description
            title
            video {
                publicURL
            }
        }
        bottomContentRows {
            buttonText
            buttonUrl
            description
            title
            video {
                publicURL
            }
        }
      }
    }
    settingsYaml {
        trialBanner {
            buttonText
            buttonUrl
            subtitle
            title
        }
        deviceBanner {
            content
            title
        }
        testimonials {
            title
            testimonial {
                image
                name
                title
                content
            }
        }
    }
  }
`


export default FeaturesPage




// WEBPACK FOOTER //
// ./src/templates/FeaturesPage.js